import React, { useCallback, useState } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { isMultiMediaDeviation } from '../../DeviationViews/_helpers';
import { useZoomBiLogger } from '../../DeviationViews/Full/hooks/useZoomBiLogger';
import { DefaultArtStageProps as Props } from '../types';
import MobileMultiArtStage from './MobileMultiArtStage';
import MobileSingleArtStage from './MobileSingleArtStage';
import { DeviantMediaWrapper } from '../../utils/DeviationMediaService/types';

export const MobileArtStage: React.FC<Props> = props => {
  const isMultiVideoFlagEnabled = useFlag('multi_video');
  const hasAdditionalMedia = props.deviation.extended?.additionalMedia?.length;
  const shouldRenderMultiImage =
    isMultiMediaDeviation(props.deviation, isMultiVideoFlagEnabled) && hasAdditionalMedia;

  const [zoomedImageSource, setZoomedImageSource] = useState<DeviantMediaWrapper | undefined>();
  const logZoomBi = useZoomBiLogger(props.deviation);
  const zoomProps = {
    zoomedImageSource,
    isZoomed: !!zoomedImageSource,
    onEnterZoomMode: useCallback(
      source => {
        setZoomedImageSource(source);
        logZoomBi(true);
      },
      [logZoomBi]
    ),
    onExitZoomMode: useCallback(() => {
      setZoomedImageSource(undefined);
      logZoomBi(false);
    }, [logZoomBi]),
  };

  return shouldRenderMultiImage ? (
    <MobileMultiArtStage {...props} {...zoomProps} />
  ) : (
    <MobileSingleArtStage {...props} {...zoomProps} />
  );
};
MobileArtStage.displayName = 'MobileArtStage';
export default MobileArtStage;
